module.exports = __webpack_public_path__ + "static/media/社交电商解决方案.10d51f7c.png";